
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer-policy",
      function () {
        return require("private-next-pages/developer-policy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer-policy"])
      });
    }
  